import React, { useRef, useEffect } from "react";

// A textarea that grows to fit its content, so text is never clipped or scrolled inside the box.
export default function AutoGrowTextarea({ value, minRows = 2, className = "", ...props }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (el) { el.style.height = "auto"; el.style.height = `${el.scrollHeight}px`; }
  }, [value]);
  return (
    <textarea ref={ref} value={value} rows={minRows}
      className={`resize-none overflow-hidden ${className}`} {...props} />
  );
}
